module.exports = "/images/purchase-hslp.png?a9183f5517a48b06f2a12e7ac8c25740";